<template>
    <div class="modal fade" id="vueMultipleAddressModal" tabindex="-1" role="dialog" aria-labelledby="vueMultipleAddressModalLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="discardData">
                        <span aria-hidden="true"></span>
                    </button>
                    <h2 class="modal-title">Shipping Addresses</h2>
                </div>
                <div class="modal-body">
                    <p class="text-center">Please select the shipping address for each item.
                        If the address is not displayed, click the "Add an Address" button.
                    </p>
                    <div>
                        <div class="th hidden-xs">
                            <div class="row">
                                <div class="col-sm-3">PRODUCT</div>
                                <div class="col-xs-9">
                                    <div class="row">
                                        <div class="col-xs-5">DESCRIPTION</div>
                                        <div class="col-xs-7">SHIPPING ADDRESS</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tb no-border" v-for="(set,setIndex) in shipItemTo">
                            <div class="row">
                                <div class="col-sm-3 cart-img">
                                    <div class="prod-container">
                                        <img v-if="set.gc" class="prod-img" src="images/giftcertificate.png"/>
                                        <img v-else class="prod-img"
                                             v-bind:src="'images/catalog/' + campaign.short_url + '/' + product[set.item_id].item_image_blank"
                                        />
                                        <div class="prod-replica">
                                            <div class="prod-replica-table">
                                                <div class="prod-replica-table-td" v-bind:class="product[set.item_id].classes">
                                                    <p v-if="!set.gc" v-for="line in shipItemTo[setIndex].lines">
                                                        {{ line }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-9">
                                    <div class="row tr" v-for="item in shipItemTo[setIndex].qtys">
                                        <div class="col-xs-5">
                                            <template v-if="set.gc == true">
                                                <p class="vc">
                                                    <span v-html="product[set.item_id].description"></span> GIFT CERTIFICATE
                                                    <div v-for="(cnt,id) in set.children">
                                                        <span v-html="baseProductChildren[id].description"></span>
                                                        ({{ cnt }} each)
                                                    </div>
                                                </p>
                                            </template>
                                            <template v-else>
                                                <p class="vc" v-html="baseProductChildren[item.item_id].description"></p>
                                            </template>
                                        </div>
                                        <div class="col-xs-7">
                                            <select v-model="item.address_id" class="form-control">
                                                <option value="0">-- Please select an address --</option>
                                                <option v-for="(addr, addr_id) in addresses" v-bind:value="addr_id">
                                                    {{ addr|addressToString }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="btn-wrap clearfix">
                            <button class="btn btn-danger pull-left" @click="onAddAnAddress">Add an Address</button>
                            <button class="btn btn-danger pull-right" @click="submitData">Save</button>
                        </div>
                    </div>
               </div>
            </div>
        </div>
    </div>
</template>

<script type="text/jsx">
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    import { mapState, mapGetters } from 'vuex'
    export default {
        name: 'multiple-address-popup',
        mixins: [
            require('../../../../../assets/js/components/frontend/mixin/filters.vue')
        ],
        data: function () {
            return this.getDefaultData();
        },
        created: function () {
            Event.$on('showMultipleAddressPopup', function () {
                $('#vueMultipleAddressModal').modal('show');
            });
            Event.$on('discardAddAnAddressPopup', function () {
                $('#vueMultipleAddressModal').modal('show');
            });
            Event.$on('submitAddAnAddressPopup', function (address) {
                console.log('Added an address: ', address);
                Event.$emit('addNewAddress', address);
                setTimeout(function () {
                    $('#vueMultipleAddressModal').modal('show');
                }, 30);
            });
        },
        beforeDestroy: function () {
            Event.$off('discardAddAnAddressPopup');
            Event.$off('submitAddAnAddressPopup');
            Event.$off('showMultipleAddressPopup');
        },
        methods: {
            getDefaultData: function () {
                return {
                    address: {
                        first_name: '',
                        middle_name: '',
                        last_name: '',
                        company: '',
                        address1: '',
                        address2: '',
                        city: '',
                        state_prov: '',
                        postal_code: '',
                        country: 'US'
                    },
                    defaultAddressId: 0 // initial zero value plays a "no-address-selected" role here
                }
            },
            reset: function () {
                Object.assign(this.$data, this.getDefaultData());
            },
            onAddAnAddress: function () {
                // $('#vueMultipleAddressModal').modal('hide'); // keep it open while adding new address
                Event.$emit('showNewAddressPopup', {
                    onDiscardEvent: 'discardAddAnAddressPopup',
                    onSubmitEvent: 'submitAddAnAddressPopup'
                });
            },
            submitData: function () {
                this.$store.commit('populateAddressMap', this.shipItemTo);
                $('#vueMultipleAddressModal').modal('hide');
            },
            discardData: function () {
                $('#vueMultipleAddressModal').modal('hide');
                Event.$emit('closeMultipleAddressPopup');
            }
        },
        computed: {
            ...mapState([
                'campaign'
            ]),
            ...mapGetters([
                'addresses',
                'addressMap'
            ]),
            ...mapGetters({
                product: 'products',
                baseProductChildren: 'baseProductShippableChildren',
                items: 'cart'
            }),
            inventory: function () {
                return {
                    items: this.$store.getters.cart,
                    qtys:  this.$store.getters.qtys
                }
            },
            shipItemTo: function () {
                var output = {};
                var addrMap = this.addressMap;
                if ('items' in this.inventory) {
                    for (var setIndex in this.inventory.items) {
                        var set = this.inventory.items[setIndex];
                        var itemId = 'item_id' in set ? set.item_id : false;
                        var isGC = ('gc' in set) ? set.gc : false;
                        var dataset = {
                            item_id: set.item_id,
                            lines: ('lines' in set) ? set.lines : [],
                            qtys: [],
                            gc: isGC,
                            children: (setIndex in this.inventory.qtys) ? this.inventory.qtys[setIndex] : {}
                        };
                        if (isGC) {
                            var k = [setIndex, itemId, 'g'].join('_');
                            var addrId = this.defaultAddressId; // not selected yet
                            if (k in this.addressMap && this.addressMap[k] in this.addresses) {
                                // previous data input should be preserved
                                addrId = this.addressMap[k];
                            }
                            dataset.qtys.push({
                                item_id: itemId,
                                item_index: 'g',
                                address_id: addrId
                            });
                        } else {
                            if (itemId in this.product) {
                                var isComposite = 'composit_item' in this.product[itemId] ?
                                    this.product[itemId].composit_item :
                                    false;
                                if (isComposite && 'parts' in this.product[itemId]) {
                                    for (var partId in this.product[itemId].parts) {
                                        var i = 0;
                                        var k = [setIndex, partId, i].join('_');
                                        var addrId = this.defaultAddressId; // not selected yet
                                        if (k in this.addressMap && this.addressMap[k] in this.addresses) {
                                            // previous data input should be preserved
                                            addrId = this.addressMap[k];
                                        }
                                        dataset.qtys.push({
                                            item_id: partId,
                                            item_index: i,
                                            address_id: addrId
                                        });
                                    }
                                }
                            }
                            if (setIndex in this.inventory.qtys) {
                                var qtys = this.inventory.qtys[setIndex];
                                for (var itemId in qtys) {
                                    if (itemId in this.baseProductChildren) {
                                        for (var i = 0; i < qtys[itemId]; i++) {
                                            var k = [setIndex, itemId, i].join('_');
                                            var addrId = this.defaultAddressId; // not selected yet
                                            if (k in this.addressMap && this.addressMap[k] in this.addresses) {
                                                // previous data input should be preserved
                                                addrId = this.addressMap[k];
                                            }
                                            dataset.qtys.push({
                                                item_id: itemId,
                                                item_index: i,
                                                address_id: addrId
                                            });
                                        }
                                    }
                                }
                            }
                        }
                        if (dataset.qtys.length > 0) {
                            output[setIndex] = dataset;
                        }
                    }
                }
                return output;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// multiple-address-popup.vue?cd38aa4c